<template>
    <div>
        <producao-tree-list></producao-tree-list>
    </div>
</template>
<script>
export default {

};
</script>

<style>
</style>